/*
 * Straight at the module, not through the utils/files barrel: that barrel
 * re-exports the file demo, which reaches back into the upload UI, so asking
 * whether a file is a zip would drag the dropzone and the form prototypes in
 * with it.
 */
import getExtension from '../../files/getExtension';

// ----------------------------------------------------------------------------

const ZIP_TYPES = new Set(['application/zip', 'application/x-zip', 'application/x-zip-compressed', 'multipart/x-zip']);

// ----------------------------------------------------------------------------

function isZip(file: File): boolean {
    if (getExtension(file.name).toLowerCase() === 'zip') {
        return true;
    }

    return ZIP_TYPES.has(file.type.toLowerCase());
}

// ----------------------------------------------------------------------------

export default isZip;
